import React from 'react';
import PropTypes from 'prop-types';

import NotificationHeader from "./components/NotificationHeader";
import NotificationContent from "./components/NotificationContent";
import NoNotifications from "./components/NoNotifications";

NotificationsMenu.propTypes = {
    notificationsToDisplay: PropTypes.array
};

function NotificationsMenu({notificationsToDisplay = []}) {
    return (
        <div style={{width: '360px'}}>
            <NotificationHeader />
            {notificationsToDisplay && notificationsToDisplay.length > 0 ? notificationsToDisplay.map((notification) => (
                <NotificationContent key={notification['@id']} notification={notification} />
            )) : (
                <NoNotifications />
            )}
        </div>
    );
}

export default NotificationsMenu;
